import FewSketches from './FewSketches';

export default FewSketches;